import { call, all } from 'redux-saga/effects';

import { formControlSaga } from './formControlSlice/formControlSagas';
import { authSaga } from './authSlice/authSagas';
import { homeSaga } from './homePageSlice/homePageSaga';
import { roleMenagmentSaga } from './roleMenagmentSlice/roleMenagmentSaga';
import { addUserSaga } from './addUserSlice/addUserSaga';
import { featureFlagSaga } from "./featureFlagSlice/featureFlagSaga"

export default function* rootSaga() {
    yield all([call(formControlSaga), call(authSaga), call(homeSaga), call(roleMenagmentSaga), call(addUserSaga), call(featureFlagSaga)]);
}
